import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Avregleringen = lazy(() => import("@/pages/elmarknaden/Avregleringen"));

export const Route = createFileRoute("/elmarknaden/avregleringen")({
  head: () => seoHead("/elmarknaden/avregleringen", { description: "Den 1 januari 1996 skildes elhandeln från elnäten. Det är därför du i dag fritt kan välja elhandlare – men inte elnätsbolag." }),
  component: () => <Avregleringen />,
});
